module.exports = __webpack_public_path__ + "static/media/workout.11b21199.webp";